import { Component, OnInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AlertsService } from '../../services/alerts.service';
import { PopupEditableGridWithBannerComponent } from '../popup-editable-grid-with-banner/popup-editable-grid-with-banner.component';
import { EditableGridWithBannerService } from './editable-grid-with-banner.service';
import { LoaderService } from '../../services/loader.service';
import { DialogService } from '../dialog/dialog.service';
import { DialogModalSize } from '../dialog/dialog-ref';
import { UtilService } from '../../services/util.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { PrintService } from '../../shared/services/print.service';
import { AppService } from '../../shared/services/app.service';
import { TemplateInterceptorComponent } from '../template-interceptor/template-interceptor.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'kx-editable-grid-with-banner',
    templateUrl: './editable-grid-with-banner.component.html',
    styleUrls: ['./editable-grid-with-banner.component.scss'],
    standalone: false
})
export class EditableGridWithBannerComponent implements OnInit {
  public _currentData: any = {};
  @Input() resource: string;
  @Output() selectedData = new EventEmitter();
  btns: any = {};
  form = new FormGroup({
    gridData: new FormControl('', Validators.required)
  });
  validIn: boolean = false;//this decided wheathet to show validation error messages
  allBpmnBtns: any = [];
  ShowComponent: boolean = true;
  buttonshow: boolean = false;
  obj: any = {};
  barcodeInfo: any;
  public sub: Subscription = new Subscription();
  
  constructor(
    public baseService: BaseService,
    public route: ActivatedRoute,
    public el: ElementRef,
    public alerts: AlertsService,
    public router: Router,
    public dialogService: DialogService,
    public utilService: UtilService,
    public GridService?: EditableGridWithBannerService,
    public loader?: LoaderService,
    public rolePermission?: RolePermissionService,
    public printService?: PrintService,
    public appService?: AppService
  ) { }

  ngOnInit() {
    this._currentData.json = this.resource != undefined && this.resource ? this.resource : this.route.snapshot.params.resource;
    this.getResource();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  //gets the resource
  getResource() {
    this.baseService.getResourceDef(this._currentData.json, (resouceDef) => {
      if (resouceDef) {
        if (resouceDef && resouceDef.page_name && resouceDef.page_name.list) {
          this.baseService.setTitle(resouceDef.page_name.list);
        }
        this._currentData['backTitle'] = this.baseService._currentTitle;
        if (this._currentData != undefined && this._currentData.backTitle != undefined)
          this.baseService.backNavigation = true;
        else
          this.baseService.backNavigation = false;
        this._currentData.currentResource = resouceDef.resource;
        this._currentData.config = resouceDef.config != undefined ? resouceDef.config : "";
        this._currentData.bannerJson = resouceDef.banner != undefined ? resouceDef.banner : "";
        if (sessionStorage && sessionStorage.getItem('currentData') && this._currentData.bannerJson)
          this._currentData.bannerJson['key'] = JSON.parse(sessionStorage.getItem('currentData'));    // 178574
        this._currentData.buttons = resouceDef.buttons != undefined ? resouceDef.buttons : [];
        if (this._currentData.buttons.length > 0) {
          this.initiateBpmnBtns();
        }

      } else {
        this._currentData['backTitle'] = this.baseService._currentTitle;
        if (this._currentData != undefined && this._currentData.backTitle != undefined)
          this.baseService.backNavigation = true;
        else
          this.baseService.backNavigation = false;
      }
    });
  }

  //for event from grid
  listen_changes(event) {
    if (event.type == 'checkbox') {
      this.showHideOnCheck(event['object']);
    }
  }

  //settings up button
  initiateBpmnBtns() {
    this.btns['cloneBtns'] = this._currentData.buttons.filter(x =>
      x.dependent === undefined && (x.permission_required != undefined && x.permission_required == true ? this.rolePermission.checkAccessPermission(x.action_name, x.resource, x.application) : true)
    );
    this._currentData.buttons.buttons = this._currentData.buttons.filter(x =>
      x.dependent != undefined && (x.permission_required != undefined && x.permission_required == true ? this.rolePermission.checkAccessPermission(x.action_name, x.resource, x.application) : true)
    );
    this.btns['avilabelBpmnBtns'] = this.btns['cloneBtns'];
  }
  //buttons Dependent
  showHideOnCheck(dataArray) {
    this.buttonshow = dataArray.length > 0 ? true : false
    var allBpmnBtns = [];
    this.btns['avilabelBpmnBtns'] = [];
    if (this._currentData.buttons.length > 0 && this._currentData.buttons != undefined && dataArray.length) {
      allBpmnBtns = JSON.parse(JSON.stringify(this._currentData.buttons));
      for (let singleField of dataArray) {
        console.log("single field is as", singleField);
        if (allBpmnBtns.length) {
          this.btns['allBpmnBtns'] = JSON.parse(JSON.stringify(allBpmnBtns));
          for (let btnIndex in this.btns['allBpmnBtns']) {
            let btns = this.btns['allBpmnBtns'][btnIndex];
            if (btns.dependent != undefined && btns.dependent.key != undefined && singleField[btns.dependent.key] != undefined && (btns.dependent.value != undefined && singleField[btns.dependent.key] == btns.dependent.value || (btns.dependent.value_eval != undefined && eval(btns.dependent.value_eval))) && (btns.permission_required != undefined && btns.permission_required == true ? this.rolePermission.checkAccessPermission(btns.action_name, btns.resource, btns.application) : true)) {
              console.log(this.btns['avilabelBpmnBtns']);
              //gets Index of object
              let index = this.getIndex(allBpmnBtns, btns);
              this.btns['avilabelBpmnBtns'].push(btns);
              allBpmnBtns.splice(index, 1);
              //break;//because one to one relationship with field, if we found one there wont' be another for same field.
            }
          }
        } else {
          break;//if there are no more bpmn btn, no need of this loop.
        }
      }
    }
    if (this.btns && this.btns['cloneBtns']){
      this.btns['avilabelBpmnBtns'] = [...this.btns['avilabelBpmnBtns'], ...this.btns['cloneBtns']]
    }
    // if (this.dataSource.buttons.dep)
  }
  //gives Index
  getIndex(array, item) {
    let clone_array = [];
    for (let i = 0; i < array.length; i++) {
      clone_array.push(JSON.stringify(array[i]));
    }
    return clone_array.indexOf(JSON.stringify(item));
  }
  onSubmit(btn?) {
    console.log(this.form.value.gridData);

    // //this condition is checked as in case of redirection thre is no need to validate user can go back or further as no data will be set in this case
    if (btn != undefined && btn.action == 'redirect_path') {
      this.performActions(btn);
    }
    //for invalid
    if (this.form.controls['gridData'].errors != null && this.form.controls['gridData'].errors.invalid == true) {
      //this makes the form control css update fires isvalid in form question
      this.validIn = true;
      return;
    }
    //for walid
    else {
      this.validIn = false;
      this.performActions(btn)
    }
  }
  //click button actions
  performActions(btn) {
    switch (btn.action) {
      case 'api_request':
        if (btn.templateInterceptor) {
          this.checkTemplates(this.form.value.gridData, btn, () => this.postData(btn.datasource, this.form.value.gridData, btn.redirect_path));
        } else {
          this.postData(btn.datasource, this.form.value.gridData, btn.redirect_path);
        }
        break;
      case 'redirect_path':
        this.redirect(btn.redirect_path);
        break;
      case 'popup_form':
        if (btn.templateInterceptor) {
          this.checkTemplates(this.form.value.gridData, btn, () => this.openpopup(btn));
        } else {
          this.openpopup(btn);
        }
        break;
      case 'transfer_data':
        this.transferData(this.form.value.gridData, btn.datasource);
        break;
      case 'print':
        this.rePrintBarcode(btn, this.form.value.gridData);
        break;
      default:
        //do nothing
        break;
    }
  }
  //checks if a clinical-consent template is configured for this action's next_stage before letting it proceed
  checkTemplates(data_, action, proceed: () => void) {
    try {
      this.loader.showSpinner();
      let datasource = action.templateInterceptor.datasource;
      let rows = data_ && data_.data != undefined ? data_.data : data_;
      let primary = Object.assign({}, rows[0]);
      primary['next_stage'] = action.templateInterceptor.next_stage;
      if (primary != undefined && !primary.care_type) {
        try { primary['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType"); } catch (error) { }
      }
      if (primary != undefined && primary.patient_gender) {
        primary['patient_gender'] = (primary.patient_gender + '').toLowerCase();
      }
      let args = this.baseService.buildDyanamicStr(datasource.args, { data: primary });
      if (datasource.appendArgs) {
        const appendedArgs = this.buildAppendArgs(rows, datasource.appendArgs);
        args = args ? args + "," + appendedArgs : appendedArgs;
      }
      this.baseService.get(datasource.query_id, args, datasource.resource, datasource.application, datasource.filter).subscribe(data => {
        if (data && data.errCode != -1 && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
          action.templateInterceptor['TemplateData'] = data.resource;
          this.openTemplIntersep(primary, { templateInterceptor: action.templateInterceptor }, false, (res) => {
            if (res) { proceed(); }
          });
        } else {
          this.loader.hideSpinner();
          proceed();
        }
      }, (error) => {
        this.loader.hideSpinner();
        proceed();
      });
    } catch (error) {
      this.loader.hideSpinner();
      proceed();
    }
  }
  //joins a field's value across every selected row for datasource.appendArgs (e.g. multiple serviceItemCodes)
  buildAppendArgs(rows, fieldName: string) {
    let template = '!!!' + fieldName + '!!!';
    let values = [];
    for (let row of rows) {
      values.push(this.baseService.buildDyanamicStr(template, { data: row }));
    }
    return fieldName + ':' + values.join('=');
  }
  openTemplIntersep(data: any, actionType, config?, callback?) {
    let popobj = { data: { action: actionType, data: data }, title: 'Template', size: DialogModalSize.Lg };
    if (config) popobj.data['config'] = config;
    this.sub.add(this.dialogService.open(TemplateInterceptorComponent, popobj).afterClosed.subscribe(res => {
      if (res) callback(true);
    }));
  }
  //send data
  postData(datasource, data?, path?) {
    this.loader.showSpinner();
    let data_ = data.data != undefined ? data.data : data;
    if (data_ != undefined) {
      try {
        let data1 = data_.filter(x => x.serviceStartTime == "" || x.collectedDateTime == "" || x.bookingDate == "" || x.standard_codes == "" || x.list_of_service == "" || x.tat == "");
        if (data1 && data1.length > 0) {
          data_.map(x => {
            if (!x.serviceStartTime) {
              delete x.serviceStartTime;
            }
            if (!x.collectedDateTime) {
              delete x.collectedDateTime;
            }
            if (!x.bookingDate) {
              delete x.bookingDate;
            }
            if (!x.standard_codes) {
              delete x.standard_codes;
            }
            if (!x.list_of_service) {   // for blood bank order raise
              delete x.list_of_service;
            }
            if (!x.tat) {   // for tat array if empty or null
              delete x.tat;
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
    this.sub.add(this.baseService.action(data, datasource.action, datasource.application, datasource.resource).subscribe(data => {
      this.loader.hideSpinner();
      if (data.errCode == -1) {
        this.alerts.error(data.message);
      }
      else {
        this._currentData.json = "";
        this.form.controls['gridData'].setValue("");
        this.alerts.success("Added Successfully");
        if (path != undefined) {
          this.redirect(path);
        }
        setTimeout(x => { this.ngOnInit(); });
      }

    }));
  }
  rePrintBarcode(info, fieldData) {
    try {
      let info_ = JSON.parse(JSON.stringify(info));
      this.obj['data'] = this.form.value.gridData;
      this.barcodeInfo = info_;
      this.form.value.gridData = fieldData;
      this.manupulateArgs(this.form.value.gridData, info_.file_data.args);
      this.handleFile(this.barcodeInfo, this.obj);
      this.barcodeInfo.file_data.args = "!!!serviceRequestId!!!";
    } catch (error) {

    }

  }
  manupulateArgs(data, args) {
    try {
      let tempArgs = JSON.parse(JSON.stringify(args));
      let finalargs = [];
      for (let val of data) {
        let strngVal = this.baseService.buildDyanamicStr(tempArgs, { 'data': val });
        finalargs.push(strngVal);
      }
      let strToSet = "serviceRequestId:" + finalargs.join('=');
      this.barcodeInfo.file_data.args = strToSet;
    } catch (error) {

    }

  }
  handleFile(action, obj, callback = null) {
    if (action.file_data != undefined) {
      var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
      this.loader.showSpinner();
      var fileObj = JSON.parse(JSON.stringify(action.file_data));
      fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
      fileObj.resource = fileObj.resource != undefined ? fileObj.resource : this._currentData.resource;
      fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
      fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;
      fileObj.args = this.baseService.appendEhrFacilityIdArg(fileObj.args, obj);
      this.baseService.handleFile(fileObj, async (fileData) => {
        if (fileData) {
          if (fileData.type == "application/json") {
            try {
              var response = await fileData.text();
              response = JSON.parse(response);
              if (response.errCode == -1 && response.message != undefined) {
                this.alerts.error(response.message);
              }
              console.log(response);
            } catch (e) {
              this.alerts.error('API error');
            }
          } else {
            fileObj.key = key;
            this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
          }
        } else {
          this.alerts.error('server error');
          if (callback) {
            callback(false);
          }

        }
        this.loader.hideSpinner();
      });
    } else {
      console.error("Please provide File Data");
      if (callback) {
        callback(false);
      }
    }
  }
  //for redirection
  redirect(path) {
    // this.router.navigateByUrl(path);
    var url: any = this.route.snapshot.queryParams && this.route.snapshot.queryParams.returnUrl ? this.route.snapshot.queryParams.returnUrl : path;
    this.router.navigateByUrl(url);
  }
  //for popup
  openpopup(btn) {
    let popobj = { data: btn.popup.form, title: btn.popup.header, size: this.GridService.checkingDialogModalSize(btn.popup.size ? btn.popup.size : '') };
    this.sub.add(this.dialogService.open(PopupEditableGridWithBannerComponent, popobj).afterClosed.subscribe(
      data => {
        if (data != undefined) {
          let data_: object = { "data": this.form.value.gridData };
          Object.assign(data_, data.result);
          if (btn != undefined && btn.simpleformat != undefined && btn.simpleformat) {
            try {
            let arr = [];
            for(let i=0;i<this.form.value.gridData.length;i++){
              let obj_:any  = this.form.value.gridData[i];
              let obj = {...obj_,...data.result};
              arr.push(obj);
            }
            data_ = arr;
            } catch (error) {
              console.error(error);
            }
          }
          //sending data to db
          this.postData(btn.datasource, data_, btn.redirect_path)
        }
      }));

    // this.smartmodelservice.open(PopupEditableGridWithBannerComponent, btn.popup.form, btn.popup.header, this.GridService.checkingModalSize(btn.popup.size ? btn.popup.size : '')).subscribe(data => {
    //   if (data) {
    //     //merging the data of grid and form
    //     let data_: object = { "data": this.form.value.gridData };
    //     Object.assign(data_, data.result);

    //     //sending data to db
    //     this.postData(btn.datasource, data_, btn.redirect_path)
    //   }
    // }, err => {
    // })
  }
  transferData(data, btn) {
    this.selectedData.emit({ 'data': data, 'btn': btn })
  }
  listResource() {
    if (this.route.snapshot.queryParams.hasOwnProperty('returnUrl')) {
      this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
    }
  }
  threeDotClick(event) {
    if (event.event && event.event.event && event.event.event.action == "viewNoteBanner") {
    } else {
      this.ShowComponent = !this.ShowComponent;
    }
  }

}
